<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';

  import type { MarketingCardStoryblok } from '$types/bloks';

  import { cn } from '$lib/utils';
  import ResponsiveImage from './marketing-sub-blocks/responsive-image.svelte';
  import ResponsiveVideo from './responsive-video.svelte';

  export let block: MarketingCardStoryblok;

  $: link = block.link?.id ? $getAnchorFromCmsLink(block.link) : null;
</script>

<div class="h-full w-full" use:storyblokEditable={block}>
  <a
    href={link?.href}
    rel={link?.rel}
    target={link?.target}
    class={cn('relative overflow-hidden rounded-md z-10 flex w-full grow h-full')}
  >
    {#if block.image && block.image?.length > 0}
      <ResponsiveImage
        image={block.image[0]}
        imgClass="w-full h-full object-cover"
        class="w-full h-full"
      />
    {:else if block.video && block.video?.length > 0}
      <ResponsiveVideo block={block.video[0]} />
    {/if}

    <div
      class={cn(
        'p-4 absolute top-0 z-10',
        block.text_color == 'black' ? 'text-primary' : 'text-highlight'
      )}
    >
      <div class="">
        {#if block.title}
          <p class="text-4xl pointer-events-none font-semibold">
            {block.title}
          </p>
        {/if}
        {#if block.subtitle}
          <p class="text-xl pointer-events-none mt-2">
            {block.subtitle}
          </p>
        {/if}
      </div>
    </div>

    <div class="absolute bottom-0 p-4 z-10 flex">
      <div
        class="flex gap-2 absolute w-full left-0 bottom-0 lg:w-auto lg:left-4 lg:bottom-4 px-2.5 py-3.5 lg:px-0 lg:py-0"
      >
        {#if block.cta_label}
          <p class="flex-1 lg:flex-none">
            <span
              class="w-full inline-block text-highlight bg-primary/18 px-3.5 py-3 rounded-xs text-center font-medium lg:font-semibold backdrop-blur text-md"
              >{block.cta_label}</span
            >
          </p>
        {/if}

        {#if block.second_cta_label && block.second_cta_link}
          <a class=" flex-1 lg:flex-none" href={$getAnchorFromCmsLink(block.second_cta_link).href}>
            <span
              class="w-full inline-block bg-background px-3.5 py-3 rounded-xs text-center font-medium lg:font-semibold backdrop-blur text-md"
              >{block.second_cta_label}</span
            >
          </a>
        {/if}
      </div>
    </div>
  </a>
</div>
